"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePoint_Actions = void 0;
const OnePointSDK_1 = require("./OnePointSDK");
exports.default = OnePointSDK_1.OnePoint;
var action_define_1 = require("./action.define");
Object.defineProperty(exports, "OnePoint_Actions", { enumerable: true, get: function () { return action_define_1.OnePoint_Actions; } });
//# sourceMappingURL=index.js.map